import Nav from 'react-bootstrap/Nav';
import { noop } from 'libs';

interface TabLinkProps {
  eventKey: string | number;
  name: string;
  onClick?: () => void;
  tabWidth?: number;
  testId?: string | null;
}

const TabLink = ({ eventKey, name, onClick = noop, tabWidth = 130, testId = null }: TabLinkProps) => (
  <Nav.Item style={{ width: tabWidth }}>
    <Nav.Link data-testid={testId} eventKey={eventKey} onClick={onClick}>
      <span>{name}</span>
      <div className="active-tab-decorator" />
    </Nav.Link>
  </Nav.Item>
);

export default TabLink;
